<!--
  -  TTTech nerve-management-system
  -  Copyright(c) 2023. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->

<template>
  <v-form ref="nodeInformationViewSystem" v-resize="onResize">
    <v-col cols="12" md="12" s="6" xs="6" class="ml-1">
      <v-row>
        <span id="iiotNodeInformationViewSystemTitle" class="node-information-title">
          {{ $t('nodes.information.system') }}
        </span>
      </v-row>
      <v-row v-resize="onResize" class="rowHeight mt-5">
        <v-col cols="10" class="pa-0">
          <v-btn
            v-if="canAccess('UI_NODE:SHOW_LOGS')"
            id="iiotNodeActionsAndInfoShowLogs"
            :href="elkUrl"
            text
            target="_blank"
            color="primary"
            class="pa-0"
          >
            {{ $t('nodes.information.internalLogs') }}
          </v-btn>
          <v-row>
            <span
              id="iiotNodeInformationViewSystemLogsDescription"
              class="text--secondary node-information-text-light mt-3 ml-3"
            >
              {{ $t('nodes.information.systemLogsDescription') }}
            </span>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        v-if="canAccess('UI_NODE:LOGGING_AND_MONITORING_SETTINGS')"
        class="rowHeight"
        :class="{ 'mt-15': isMarginVisible }"
      >
        <v-col cols="10" class="pa-0">
          <div>
            <v-btn
              id="iiotNodeInformationViewSystemMetrics"
              text
              color="primary"
              class="pa-0"
              :href="systemUrl"
              target="_blank"
            >
              {{ $t('nodes.information.systemMetrics') }}
            </v-btn>
            <v-row>
              <span
                id="iiotNodeInformationViewSystemMetricsDescription"
                class="text--secondary node-information-text-light mt-3 ml-3"
              >
                {{ $t('nodes.information.systemMetricsDescription') }}
              </span>
            </v-row>
          </div>
        </v-col>
        <v-col
          v-if="
            canAccess('UI_NODE_LOG_LEVEL:MANAGE_LOG_LEVELS') && canAccess('UI_NODE:LOGGING_AND_MONITORING_SETTINGS')
          "
          cols="1"
        >
          <v-checkbox
            v-if="
              selectedNode.isOnline() &&
              monitoringAndLoggingStatus &&
              monitoringAndLoggingStatus.loggingMonitoring &&
              !filebeatError
            "
            id="iiotNodeInformationViewSystemMetricsCheckbox"
            v-model="monitoringAndLoggingStatus.loggingMonitoring.systemMonitoring"
            data-cy="iiotNodeInformationViewSystemMetricsCheckbox"
            class="pr-5"
            @change="changed"
          />
        </v-col>
        <v-col
          v-if="
            !canAccess('UI_NODE_LOG_LEVEL:MANAGE_LOG_LEVELS') && canAccess('UI_NODE:LOGGING_AND_MONITORING_SETTINGS')
          "
          cols="1"
        >
          <v-checkbox
            v-if="selectedNode.isOnline() && monitoringAndLoggingStatus && !filebeatError"
            id="iiotNodeInformationViewSystemMetricsCheckbox"
            v-model="monitoringAndLoggingStatus.systemMonitoring"
            data-cy="iiotNodeInformationViewSystemMetricsCheckbox"
            class="pr-5"
            @change="changed"
          >
          </v-checkbox>
        </v-col>
      </v-row>
    </v-col>
  </v-form>
</template>
<script>
export default {
  props: {
    selectedNode: {
      type: Object,
      default: () => {},
    },
    filebeatError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChanged: false,
      isMarginVisible: false,
    };
  },
  computed: {
    elkUrl() {
      return `${
        'opensearch/app/discover#/?' +
        '_g=(refreshInterval:(pause:!t,value:0),' +
        'time:(from:now-3h,to:now))' +
        "&_a=(columns:!('@timestamp',host.hostname,message,syslog.severity_label),filters:!(('$state':(store:appState)," +
        "meta:(alias:!n,disabled:!f,index:'243502e0-6185-11ea-b149-f7a361aca0a3'," +
        "key:tags,negate:!f,params:(query:'"
      }${this.selectedNode.serialNumber}'),type:phrase,value:'${
        this.selectedNode.serialNumber
      }'),query:(match:(tags:(query:'${
        this.selectedNode.serialNumber
      }',type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'243502e0-6185-11ea-b149-f7a361aca0a3',key:syslog.severity_label,negate:!f,params:!(Error,Warning),type:phrases,value:'Error, Warning'),query:(bool:(minimum_should_match:1,should:!((match_phrase:(syslog.severity_label:Error)),(match_phrase:(syslog.severity_label:Warning))))))),index:'243502e0-6185-11ea-b149-f7a361aca0a3',interval:auto,query:(language:kuery,query:''),sort:!('@timestamp',desc))`;
    },
    systemUrl() {
      return `${
        'opensearch/app/dashboards#/view/' +
        'cb013110-86ce-11eb-8fb9-ef7af830d753?' +
        "_a=(description:'Overview%20of%20host%20metrics%20on%20node.',filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'243502e0-6185-11ea-b149-f7a361aca0a3',key:message,negate:!f,params:(query:'"
      }${+this.selectedNode.serialNumber}'),type:phrase),query:(match_phrase:(tags:'${
        this.selectedNode.serialNumber
      }')))),fullScreenMode:!f,options:(darkTheme:!f),panels:!((embeddableConfig:(title:'CPU%20Usage'),gridData:(h:10,i:'10',w:8,x:0,y:0),id:'83e12df0-1b91-11e7-bec4-a5e9ec5cab8b-ecs',panelIndex:'10',title:'CPU%20Usage',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Memory%20Usage'),gridData:(h:10,i:'11',w:8,x:8,y:0),id:d3166e80-1b91-11e7-bec4-a5e9ec5cab8b-ecs,panelIndex:'11',title:'Memory%20Usage',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Outbound%20Traffic%20by%20Interface'),gridData:(h:15,i:'28',w:24,x:24,y:25),id:c5e3cf90-4d60-11e7-9a4c-ed99bbcaa42b-ecs,panelIndex:'28',title:'Outbound%20Traffic%20by%20Interface',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Used%20Disk%20Space'),gridData:(h:10,i:d27750fa-43ee-452a-ade0-6d29ae0427f4,w:8,x:16,y:0),id:'5b3f7d70-86cc-11eb-8fb9-ef7af830d753',panelIndex:d27750fa-43ee-452a-ade0-6d29ae0427f4,title:'Used%20Disk%20Space',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Outbound%20Traffic'),gridData:(h:10,i:'8c02e4a4-2303-4354-a470-8e2a20e91013',w:8,x:32,y:0),id:'9ea68ea0-8857-11eb-920a-bd1ef53410fc',panelIndex:'8c02e4a4-2303-4354-a470-8e2a20e91013',title:'Outbound%20Traffic',type:visualization,version:'7.7.0'),(embeddableConfig:(title:Packetloss),gridData:(h:10,i:bd0bfac5-d155-46d0-94d1-caf7d968c8f3,w:8,x:40,y:0),id:'2667f9a0-8858-11eb-920a-bd1ef53410fc',panelIndex:bd0bfac5-d155-46d0-94d1-caf7d968c8f3,title:Packetloss,type:visualization,version:'7.7.0'),(embeddableConfig:(title:'CPU%20Usage'),gridData:(h:15,i:'0dbf3f93-135b-457c-b0cb-189e70fd7b0d',w:16,x:0,y:10),id:'113763a0-8861-11eb-920a-bd1ef53410fc',panelIndex:'0dbf3f93-135b-457c-b0cb-189e70fd7b0d',title:'CPU%20Usage',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Disk%20IO'),gridData:(h:15,i:b52652ee-144e-48eb-80db-2f10ccf21235,w:16,x:32,y:10),id:'017e8220-8863-11eb-920a-bd1ef53410fc',panelIndex:b52652ee-144e-48eb-80db-2f10ccf21235,title:'Disk%20IO',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Inbound%20Traffic'),gridData:(h:10,i:f1edf0ea-24a6-43f5-a90a-4a12d88a475a,w:8,x:24,y:0),id:a7cc2130-8856-11eb-920a-bd1ef53410fc,panelIndex:f1edf0ea-24a6-43f5-a90a-4a12d88a475a,title:'Inbound%20Traffic',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Memory%20Usage'),gridData:(h:15,i:'62a2c96e-577b-4e28-8039-6e5aa18f99fe',w:16,x:16,y:10),id:'90f1cb70-8862-11eb-920a-bd1ef53410fc',panelIndex:'62a2c96e-577b-4e28-8039-6e5aa18f99fe',title:'Memory%20Usage',type:visualization,version:'7.7.0'),(embeddableConfig:(title:'Inbound%20Traffic%20by%20Interface'),gridData:(h:15,i:'209494ae-ec74-445a-b18a-30b0081c2fc0',w:24,x:0,y:25),id:'6f68f560-9c48-11eb-ad0c-79eae28dbbd9',panelIndex:'209494ae-ec74-445a-b18a-30b0081c2fc0',title:'Inbound%20Traffic%20by%20Interface',type:visualization,version:'7.7.0')),query:(language:kuery,query:''),timeRestore:!t,title:'Node%20Utilization%20Dashboard',viewMode:view)&_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-1h,to:now))`;
    },
    monitoringAndLoggingStatus() {
      return this.$store.getters['nodes/getMonitoringAndLoggingSettings'];
    },
    initialValues() {
      return this.$store.getters['nodes/getMonitoringAndLoggingSettingsInitialValues'];
    },
  },
  methods: {
    async mounted() {
      this.$store.dispatch('node-tree/restart_mqtt_events', this.selectedNode);
    },
    beforeDestroy() {
      this.$store.dispatch('node-tree/clear_exchange_interval');
      this.$mqtt.unsubscribeFrom('node', this.selectedNode);
    },
    changed() {
      if (
        !(
          this.canAccess('UI_NODE_LOG_LEVEL:MANAGE_LOG_LEVELS') &&
          this.canAccess('UI_NODE:LOGGING_AND_MONITORING_SETTINGS')
        )
      ) {
        this.isChanged = this.monitoringAndLoggingStatus.systemMonitoring !== this.initialValues.systemMonitoring;
      } else {
        this.isChanged =
          this.monitoringAndLoggingStatus.loggingMonitoring.systemMonitoring !==
          this.initialValues.loggingMonitoring.systemMonitoring;
      }
      if (this.isChanged) {
        this.$store.dispatch('nodes/set_view_system_save_enabled', {
          isViewChanged: this.isChanged,
        });
      }
      if (!this.isChanged) {
        this.$store.dispatch('nodes/disable_view_system_button', { isViewChanged: this.isChanged });
      }
    },
    onResize() {
      this.isMarginVisible = window.innerWidth < 820 && window.innerWidth > 738;
    },
  },
};
</script>

<style lang="scss">
.node-information-text-light {
  font-size: 13px;
}
.node-information-text {
  font-size: 14px;
}
.node-information-title {
  font-size: 18px;
  font-weight: 87%;
}
.rowHeight {
  height: 85px;
}
</style>
